import { Edit as ReactAdminEdit, SimpleForm, NumberInput } from "react-admin";

export const Edit: React.FC = () => (
    <ReactAdminEdit>
        <SimpleForm>
            <NumberInput source="RewardAmount" step={5} />
        </SimpleForm>
    </ReactAdminEdit>
);
